import { render, staticRenderFns } from "./PortalModal.vue?vue&type=template&id=3af0f273&scoped=true&"
import script from "./PortalModal.vue?vue&type=script&lang=js&"
export * from "./PortalModal.vue?vue&type=script&lang=js&"
import style0 from "./PortalModal.vue?vue&type=style&index=0&id=3af0f273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0f273",
  null
  
)

export default component.exports